import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { Article, ArticleUnit, ArticleDescr, ArticleListElement } from './article';
import { ArticleService } from './article.service';
import { Message, ConfirmationService } from 'primeng/primeng';

@Component({
  selector: 'app-article',
  templateUrl: './article.component.html',
  styleUrls: ['./article.component.css'],
  providers: [ConfirmationService]
})
export class ArticleComponent implements OnInit {

  public articleList: ArticleListElement[];
  public msgs: Message[] = [];
  public selectedArticle: Article;

  constructor(private articleService: ArticleService, private router: Router,
    private confirmationService: ConfirmationService) {
    this.articleList = [];
  }

  ngOnInit() {
    this.loadArticles();
  }

  private loadArticles() {
    this.articleService.list().subscribe(
      (articleListDTO: Article[]) => {
        this.articleList = [];
        if (articleListDTO != null) {
          for (var article of articleListDTO) {
            let listElement: ArticleListElement = new ArticleListElement();
            listElement.id = article.id;
            listElement.articleNumber = article.articleNumber;
            listElement.weight = article.weight;
            if (article.descr != null) {
              listElement.name1 = article.descr[0].name1;
              listElement.name2 = article.descr[0].name2;
            }
            listElement.charge = article.charge;
            for (var unit of article.units) {
              if (unit.id == article.baseUnitId) {
                listElement.baseUnit = unit.unit;
              }
            }
            listElement.pickable = article.pickable;
            listElement.serialNumber = article.serialNumber;

            this.articleList = [...this.articleList, listElement];
          }
        }
      },
      (err) => {
        console.log(err);
        this.msgs.push({ severity: 'warn', summary: 'Error', detail: 'Could not load list of articles.' });
      }
    );
  }

  public addNew() {
    console.log('Navigate to new Article component.');
    this.router.navigateByUrl('/article/new');
  }

  /**
   * Navigate to details component
   */
  public editSelected() {
    if (this.selectedArticle == null) {
      this.msgs = [];
      this.msgs.push({ severity: 'info', summary: 'Keine Artikel ausgewaehlt.' });
    }

    this.router.navigate(['/article', this.selectedArticle.id])
  }

  public deleteSelected() {
    this.msgs = [];
    if (this.selectedArticle == null) {
      this.msgs.push({ severity: 'info', summary: 'Keine Artikel ausgewaehlt.' });
      return;
    }
    this.confirmationService.confirm({
      message: 'Moechten Sie den Artikel wirlich loeschen?',
      accept: () => {
        this.articleService.delete(this.selectedArticle.id).subscribe(
          (success: any) => {
            if (success != null && success.success) {
              this.msgs.push({ severity: 'info', summary: 'Artikel wurde geloescht.' });
              this.loadArticles();
            } else {
              this.msgs.push({ severity: 'warn', summary: 'Artikel konnte nicht geloescht werden.' });
              console.log('Error on serverside.');
            }
          },
          (err) => {
            this.msgs.push({ severity: 'warn', summary: 'Artikel konnte nicht geloescht werden.' });
            console.log(err);
          }
        );
      }
    });

  }

}



// WEBPACK FOOTER //
// /home/pneuser/workspace/pepelogistic/pepeLogisticControl/src/app/article/article.component.ts